<template>
  <v-menu
      v-model="menuOpen"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      :key="render"
    >
    <template v-slot:activator="{on}">
    <v-text-field
        :suffix="currency.key"
        prepend-icon="mdi-cash"
        v-model="localValue"
        v-mask="currencyMask"
        :hint="originalCurrencyHint"
        persistent-hint
        v-on={on}
        @click:prepend="openMenu"
        @paste.prevent="handleInputPaste"
        v-bind="$attrs"
        @focus="handleFocus"
      >
      </v-text-field>
    </template>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                {{ $t('common.value') }}
              </th>
              <th class="text-left">
                {{ $t('common.currency') }}
              </th>
              <th class="text-right">
                {{ $t('common.ratio') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="currency in currencies"
              :key="currency.key"
            >
              <td class="text-right">{{value | formatCurrency(currency)}}</td>
              <td class="text-left">{{ currency.key}}</td>
              <td class="text-right">{{ currency.value }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-menu>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'VfCurrencyInput',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    currency: {
      type: Object,
      default: function () {
        return { key: 'EUR', value: 1 }
      }
    },
    currencies: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      menuOpen: false,
      currencyMask: createNumberMask({
        prefix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ' ',
        allowNegative: true,
        allowDecimal: true,
        decimalSymbol: ',',
        decimalLimit: 2
      }),
      localValue: this.getStringInputValue(this.value),
      lastValue: this.value,
      render: 0
    }
  },
  computed: {
    originalCurrencyHint () {
      return this.currency.value !== 1 && this.currencies[0]
        ? this.$t('common.originalCurrency', { currency: this.currencies[0].key })
        : ''
    }
  },
  watch: {
    value (value) {
      if (value === this.lastValue) {
        return
      }

      this.render++
      this.localValue = this.isValueAMinus(value) ? value : this.getStringInputValue(value)
    },
    localValue (value) {
      const cleanValue = value
        ? value.replace(/[ ]+/g, '').trim().replace(',', '.')
        : '0'

      const outputValue = this.isValueAMinus(cleanValue) ? cleanValue : Math.round((parseFloat(cleanValue) * 100) / this.currency.value)

      if (outputValue !== this.lastValue) {
        this.lastValue = this.isValueAMinus(outputValue) ? 0 : outputValue
        this.$emit(
          'input',
          this.lastValue
        )
      }
    }
  },
  methods: {
    openMenu () {
      this.menuOpen = true
    },
    getStringInputValue (value) {
      return ((parseInt(value) / 100) * this.currency.value).toString().replace('.', ',')
    },
    handleInputPaste (e) {
      const pastedText = e.clipboardData.getData('text')
      // rough text cleanup to ensure mask compatibility
      this.localValue = pastedText.replace('.', ',')
      this.render++
    },
    isValueAMinus (value) {
      return value === '-'
    },
    handleFocus () {
      this.$emit('focus')
    }
  }
}
</script>
